module.exports = __webpack_public_path__ + "media/images/backgrounds/background-feature-logs-vertical-30fb7ba0351446b5a9996f629abeaafc.svg";